import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    const cleanPhone = phone.replace(/\D/g, "").replace(/^91/, "");
    if (cleanPhone && cleanPhone.length !== 10) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }
    setBusy(true);
    const res = await register(name, email, cleanPhone, pwd);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome to ELMNTS Club. +100 points credited.");
      navigate("/", { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2 bg-white" data-testid="register-page">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1 bg-white">
        <form onSubmit={submit} className="w-full max-w-md space-y-5">
          <div>
            <div className="font-mono text-xs text-[#FF3B30] tracking-widest">ELMNTS / CREATE ACCOUNT</div>
            <h1 className="font-display text-5xl tracking-tighter mt-2 text-black">SIGN UP</h1>
            <p className="text-black/60 mt-2 text-sm">Join the club. Earn 100 points free.</p>
          </div>
          <label className="block">
            <span className="font-display tracking-widest text-[10px] text-black/50">NAME</span>
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-transparent border-b border-black/30 focus:border-black outline-none py-3 text-black"
              data-testid="register-name"
            />
          </label>
          <label className="block">
            <span className="font-display tracking-widest text-[10px] text-black/50">EMAIL</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-black/30 focus:border-black outline-none py-3 text-black"
              data-testid="register-email"
            />
          </label>
          <label className="block">
            <span className="font-display tracking-widest text-[10px] text-black/50">MOBILE NUMBER</span>
            <div className="flex items-center border-b border-black/30 focus-within:border-black">
              <span className="font-mono text-sm text-black/60 pr-2 border-r border-black/20 mr-3 py-3">+91</span>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]{10}"
                maxLength={10}
                placeholder="98765 43210"
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                className="flex-1 bg-transparent outline-none py-3 text-black placeholder:text-black/30"
                data-testid="register-phone"
              />
            </div>
            <span className="text-[10px] font-mono text-black/40 mt-1 block">For order updates via WhatsApp & SMS</span>
          </label>
          <label className="block">
            <span className="font-display tracking-widest text-[10px] text-black/50">PASSWORD (MIN 6 CHARS)</span>
            <input
              type="password"
              required
              minLength={6}
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              className="w-full bg-transparent border-b border-black/30 focus:border-black outline-none py-3 text-black"
              data-testid="register-password"
            />
          </label>
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-black text-white py-4 font-display tracking-widest text-sm hover:bg-[#FF3B30] transition-colors disabled:opacity-60"
            data-testid="register-submit"
          >
            {busy ? "CREATING..." : "CREATE ACCOUNT"}
          </button>
          <p className="text-sm text-black/60 text-center">
            Already a member? <Link to="/login" className="underline font-semibold text-black hover:text-[#FF3B30]" data-testid="link-login">LOG IN</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1768084356884-22bb77e76931" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tl from-black via-black/40 to-transparent" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <h2 className="font-display text-7xl tracking-tighter leading-[0.85]">JOIN THE<br /><span className="text-[#FF3B30]">ELMNTS</span><br />CLUB.</h2>
          <p className="text-white/80 mt-6 max-w-md">100 welcome points. Early drop access. Free priority shipping.</p>
        </div>
      </div>
    </div>
  );
}
